import { TODO_LIST } from "../actions/utilities";

const INITIAL_STATE = {
  getAllUserToDoLoading: false,
  getAllUserToDoSuccess: false,
  getAllUserToDoFailure: false,
  getAllUserToDoError: null,
  getAllUserToDoData: [],

  createToDoListLoading: false,
  createToDoListSuccess: false,
  createToDoListFailure: false,
  createToDoListError: null,
};

export const toDoListReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TODO_LIST.GET_ALL_USER_TODO_REQUEST:
      return {
        ...state,
        getAllUserToDoLoading: true,
        getAllUserToDoSuccess: false,
        getAllUserToDoFailure: false,
        getAllUserToDoError: null,
      };
    case TODO_LIST.GET_ALL_USER_TODO_SUCCESS:
      return {
        ...state,
        getAllUserToDoLoading: false,
        getAllUserToDoSuccess: true,
        getAllUserToDoFailure: false,
        getAllUserToDoData: action.payload,
        getAllUserToDoError: null,
      };
    case TODO_LIST.GET_ALL_USER_TODO_FAILURE:
      return {
        ...state,
        getAllUserToDoLoading: false,
        getAllUserToDoSuccess: false,
        getAllUserToDoFailure: true,
        getAllUserToDoError: action.payload,
      };

    case TODO_LIST.CREATE_TODO_LIST_REQUEST:
      return {
        ...state,
        createToDoListLoading: true,
        createToDoListSuccess: false,
        createToDoListFailure: false,
        createToDoListError: null,
      };
    case TODO_LIST.CREATE_TODO_LIST_SUCCESS:
      return {
        ...state,
        createToDoListLoading: false,
        createToDoListSuccess: true,
        createToDoListFailure: false,
        createToDoListError: null,
      };
    case TODO_LIST.CREATE_TODO_LIST_FAILURE:
      return {
        ...state,
        createToDoListLoading: false,
        createToDoListSuccess: false,
        createToDoListFailure: true,
        createToDoListError: action.payload,
      };

    default:
      return state;
  }
};
